__webpack_require__.p = "/twitchEXINT/";